import SlhNavigationAvatar from "./src/avatar";
import type { UserType } from "./src/avatar.type";
import { Sizes, PixelSizes, AVATAR_BACKGROUND_COLORS } from "./src/avatar.type";

export type { UserType };
export { SlhNavigationAvatar, Sizes, PixelSizes, AVATAR_BACKGROUND_COLORS };
